/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '/',
  name: 'root',
  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '/:siteId(ca)', // '/:siteId(us|ca)',
      name: 'site',
      children: [
        {
          path: '/',
          name: 'home',
          load: () =>
            import(/* webpackChunkName: 'loyalty' */ './site/default'),
        },
        {
          path: '/forbidden',
          name: 'forbidden',
          load: () => import(/* webpackChunkName: 'not-found' */ './forbidden'),
        },
        {
          path: '/account',
          name: 'account',
          load: () =>
            import(/* webpackChunkName: 'loyalty' */ './site/account'),
        },
        // {
        //   path: '/help',
        //   name: 'help',
        //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/help'),
        // },
        // {
        //   path: '/about',
        //   name: 'about',
        //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/about'),
        // },
        // {
        //   path: '/about/:id',
        //   name: 'about-detail',
        //   load: () =>
        //     import(/* webpackChunkName: 'loyalty' */ './site/about-detail'),
        // },
        // {
        //   path: '/news',
        //   name: 'news',
        //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/news'),
        // },
        // {
        //   path: '/news/:id',
        //   name: 'news-detail',
        //   load: () =>
        //     import(/* webpackChunkName: 'loyalty' */ './site/news-detail'),
        // },
        // {
        //   path: '/education',
        //   name: 'education',
        //   load: () =>
        //     import(/* webpackChunkName: 'loyalty' */ './site/education'),
        // },
        // {
        //   path: '/education/:id',
        //   name: 'education-detail',
        //   load: () =>
        //     import(/* webpackChunkName: 'loyalty' */ './site/education-detail'),
        // },
        // {
        //   path: '/page/:slug',
        //   name: 'page',
        //   load: () => import(/* webpackChunkName: 'loyalty' */ './site/page'),
        // },
        // {
        //   path: '/products',
        //   name: 'products',
        //   load: () =>
        //     import(/* webpackChunkName: 'loyalty' */ './site/products'),
        // },
        // {
        //   path: '/product/:id',
        //   name: 'product-detail',
        //   load: () =>
        //     import(/* webpackChunkName: 'loyalty' */ './site/product-detail'),
        // },
        {
          path: '/r/:scope',
          name: 'redirect',
          load: () =>
            import(/* webpackChunkName: 'loyalty' */ './site/redirect'),
        },
        // {
        //   path: '/tbh',
        //   name: 'tbhredirect',
        //   action(context, { siteId }) {
        //     return siteId === 'ca'
        //       ? {
        //           redirect:
        //             'https://myskp.com/ca/news/5d56f959f152488d8a061aa6',
        //         }
        //       : null;
        //   },
        // },
        // {
        //   path: '/backtobusy',
        //   name: 'backtobusy',
        //   action(context, { siteId }) {
        //     return siteId === 'ca'
        //       ? {
        //           redirect:
        //             'https://myskp.com/ca/page/5ee265950ff9043f01524272',
        //         }
        //       : null;
        //   },
        // },
        // require('./site/rewards').default,
        require('./site/auth').default,
        // require('./site/cart').default,
        require('./site/advisornet').default,
        require('./site/mytracker').default,
        require('./site/control').default,
        require('./site/filevault').default,
        require('./site/etl').default,
        // require('./site/poe').default,
        // require('./site/loyalty').default,
        require('./site/salondb').default,
        require('./site/education-rewards').default,
        // require('./site/messenger').default,
      ],
    },
    {
      path: '/global',
      name: 'global',
      children: [
        {
          path: '/',
          name: 'global-index',
          load: () =>
            import(/* webpackChunkName: 'global' */ './global/default'),
        },
      ],
    },
    // Wildcard routes, e.g. { path: '*', ... } (must go last)
    {
      path: '*',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'} - ${process.env.APP_NAME ||
      'Henkel Beauty Pro'}`;
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/client/index.js